class HeroSlideshow {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-slideshow__slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slideshow__dot'));
    this.prevBtn = el.querySelector('.hero-slideshow__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slideshow__arrow--next');

    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 6000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.gotoSlide, 10)));
    });

    // Pause on hover / focus
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());
    this.el.addEventListener('focusin', () => this.stopAutoplay());
    this.el.addEventListener('focusout', () => this.startAutoplay());

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });

    // Basic swipe support
    let touchStartX = 0;
    this.el.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    this.el.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        delta > 0 ? this.go(this.current - 1) : this.go(this.current + 1);
      }
    }, { passive: true });
  }

  go(index) {
    const total = this.slides.length;
    const nextIndex = (index + total) % total;
    if (nextIndex === this.current) return;

    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'false');

    this.slides[nextIndex].classList.add('is-active');
    this.slides[nextIndex].removeAttribute('aria-hidden');
    this.dots[nextIndex] && this.dots[nextIndex].classList.add('is-active');
    this.dots[nextIndex] && this.dots[nextIndex].setAttribute('aria-selected', 'true');

    this.current = nextIndex;
    this.restartAutoplay();
  }

  startAutoplay() {
    if (!this.autoplay || this.timer) return;
    this.timer = setInterval(() => this.go(this.current + 1), this.speed);
  }

  stopAutoplay() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-slideshow').forEach((el) => new HeroSlideshow(el));
});